<template>
  <div id="payerC2CEdit">
    <header-nav
      :content="`${$t('pages_router_007')} / ${
        editForm.id ? $t('pages_router_061') : $t('pages_router_060')
      }`"
    />
    <div class="common-card-body">
      <a-steps :current="0" size="small" class="payee-edit-steps">
        <a-step :title="$t('pages_pay_014')" />
        <a-step :title="$t('pages_pay_015')" />
        <a-step :title="$t('pages_pay_016')" />
      </a-steps>
      <div v-if="editForm.id && spinLoading" class="spinning-load">
        <a-spin :tip="$t('common_text_045')" />
      </div>
      <a-form
        v-else
        ref="editRef"
        :model="editForm"
        :rules="editRules"
        class="payee-edit-form ant-round-form"
        layout="vertical"
      >
        <div class="area-title">{{ $t("pages_pay_205") }}</div>
        <div class="area-form">
          <a-form-item
            name="payerCountry"
            :required="true"
            :label="$t('pages_pay_376')"
          >
            <a-select
              v-model:value="editForm.payerCountry"
              allow-clear
              show-search
              option-label-prop="label"
              option-filter-prop="label"
              :disabled="disabled"
              :placeholder="$t('common_text_005') + $t('pages_pay_376')"
            >
              <a-select-option
                v-for="item in outboundCountries"
                :key="item.id"
                :value="item.areaCode"
                :label="`${item.country} - ${item.countryChineseName}`"
              >
                <span>{{ item.country }} - {{ item.countryChineseName }}</span>
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item
            name="payerType"
            :required="true"
            :label="$t('pages_pay_252')"
          >
            <a-radio-group
              v-model:value="editForm.payerType"
              button-style="solid"
              :disabled="disabled"
            >
              <a-radio-button value="00">{{
                $t("pages_pay_207")
              }}</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item
            name="payerFirstName"
            :label="$t('pages_pay_377')"
            :required="true"
          >
            <a-input
              v-model:value="editForm.payerFirstName"
              allow-clear
              :disabled="disabled"
              :placeholder="$t('common_text_006') + $t('pages_pay_377')"
            />
          </a-form-item>
          <a-form-item
            name="payerLastName"
            :label="$t('pages_pay_378')"
            :required="true"
          >
            <a-input
              v-model:value="editForm.payerLastName"
              allow-clear
              :disabled="disabled"
              :placeholder="$t('common_text_006') + $t('pages_pay_378')"
            />
          </a-form-item>
          <a-form-item
            name="identificationType"
            :required="true"
            :label="$t('pages_merchant_072')"
          >
            <a-select
              v-model:value="editForm.identificationType"
              allow-clear
              show-search
              :disabled="disabled"
              :placeholder="$t('common_text_005') + $t('pages_merchant_072')"
            >
              <a-select-option
                v-for="item in certTypeList"
                :key="item.code"
                :value="item.code"
              ><span>{{ item.name }}</span></a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            name="identificationNumber"
            :label="$t('pages_pay_379')"
            :required="true"
          >
            <a-input
              v-model:value="editForm.identificationNumber"
              allow-clear
              :disabled="disabled"
              :placeholder="$t('common_text_006') + $t('pages_pay_379')"
            />
          </a-form-item>
          <!-- 日期 -->
          <a-form-item
            name="idExpiryDate"
            :required="true"
            :label="$t('pages_pay_380')"
          >
            <a-date-picker
              v-model:value="editForm.idExpiryDate"
              format="YYYY/MM/DD"
              value-format="YYYY-MM-DD"
              :disabled="disabled"
              :placeholder="$t('common_text_005') + $t('pages_pay_380')"
            />
          </a-form-item>
          <!-- 日期 -->
          <a-form-item
            name="birthdate"
            :required="true"
            :label="$t('pages_merchant_138')"
          >
            <a-date-picker
              v-model:value="editForm.birthdate"
              format="YYYY/MM/DD"
              value-format="YYYY-MM-DD"
              :disabled="disabled"
              :placeholder="$t('common_text_005') + $t('pages_merchant_138')"
            />
          </a-form-item>
          <a-form-item
            name="contactNumber"
            :label="$t('pages_pay_381')"
            :required="true"
          >
            <a-input
              v-model:value="editForm.contactNumber"
              allow-clear
              :disabled="disabled"
              :placeholder="$t('common_text_006') + $t('pages_pay_381')"
            />
          </a-form-item>
          <a-form-item
            name="emailAddress"
            :label="$t('pages_pay_382')"
            :required="true"
          >
            <a-input
              v-model:value="editForm.emailAddress"
              allow-clear
              :disabled="disabled"
              :placeholder="$t('common_text_006') + $t('pages_pay_382')"
            />
          </a-form-item>
          <a-form-item
            name="occupation"
            :label="$t('pages_pay_383')"
            :required="true"
          >
            <a-input
              v-model:value="editForm.occupation"
              allow-clear
              :disabled="disabled"
              :placeholder="$t('common_text_006') + $t('pages_pay_383')"
            />
          </a-form-item>
          <!-- 资金来源 -->
          <a-form-item
            name="fundSource"
            :required="true"
            :label="$t('pages_pay_384')"
          >
            <!-- <div class="explain">{{ $t("pages_merchant_081") }}</div>
            <div class="header-title">
              {{ $t("pages_merchant_082") }}{{ $t("pages_merchant_083") }}
              <span style="font-size: 12px">{{ $t("pages_merchant_063") }}</span>
            </div> -->
            <a-select
              v-model:value="editForm.fundSource"
              style="width: 100%"
              show-search
              size="large"
              option-filter-prop="label"
              :disabled="disabled"
              :placeholder="$t('common_text_005') + $t('pages_pay_384')"
            >
              <a-select-option
                v-for="item in sourceFunds"
                :key="item.code"
                :value="item.code"
              >{{ $t(item.name) }}</a-select-option>
            </a-select>
          </a-form-item>
          <!-- 地区 -->
          <a-form-item
            :required="true"
            :label="$t('pages_pay_31601')"
            style="margin-bottom: 0"
          >
            <div style="display: flex">
              <a-form-item
                name="provinceAddr"
                style="width: 31%; overflow: auto; padding: 1px 2px"
                :required="true"
              >
                <a-select
                  v-model:value="editForm.provinceAddr"
                  allow-clear
                  show-search
                  option-label-prop="label"
                  option-filter-prop="label"
                  :placeholder="$t('pages_pay_317')"
                  :disabled="disabled"
                  @change="loadProvinces"
                >
                  <a-select-option
                    v-for="item in countries"
                    :key="item.id"
                    :value="item.countryCode"
                    :label="item.countryEnglishName"
                  >
                    <span>{{ item.countryEnglishName }}</span>
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item
                name="cityAddr"
                style="width: 31%; margin-left: 3.5%; padding: 1px 2px"
                :required="true"
              >
                <a-select
                  v-model:value="editForm.cityAddr"
                  allow-clear
                  show-search
                  :disabled="disabled"
                  :placeholder="$t('pages_pay_318')"
                  @change="loadCities"
                >
                  <a-select-option
                    v-for="item in provinces"
                    :key="item.statesCode"
                    :value="item.statesEnglishName"
                  >
                    <span>{{ item.statesEnglishName }}</span>
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item
                name="areaAddr"
                style="width: 31%; margin-left: 3.5%; padding: 1px 2px"
                :required="true"
              >
                <a-select
                  v-model:value="editForm.areaAddr"
                  allow-clear
                  show-search
                  :disabled="disabled"
                  :placeholder="$t('pages_pay_319')"
                >
                  <a-select-option
                    v-for="item in cities"
                    :key="item.cityEnglishName"
                    :value="item.cityEnglishName"
                  >
                    <span>{{ item.cityEnglishName }}</span>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <a-form-item
              name="detailAddr"
              :rules="{ required: true, max: 256 }"
            >
              <a-textarea
                v-model:value="editForm.detailAddr"
                class="input-primary"
                allow-clear
                :disabled="disabled"
                :placeholder="$t('pages_pay_3201')"
              />
            </a-form-item>
          </a-form-item>
          <a-form-item
            name="postalCode"
            :label="$t('pages_pay_321')"
            :required="true"
          >
            <a-input
              v-model:value="editForm.postalCode"
              allow-clear
              :disabled="disabled"
              :placeholder="$t('common_text_006') + $t('pages_pay_321')"
            />
          </a-form-item>
        </div>
        <!-- 上传文件 -->
        <div class="area-form" style="width: 588px">
          <a-form-item
            name="identityDocument"
            :required="true"
            :label="$t('pages_holder_013')"
          >
            <upload-auto
              ref="uploadRef"
              v-model:file-content="editForm.identityDocument"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip,.rar"
              list-type="picture"
              :explain="$t('pages_pay_387')"
              :max-count="10"
              :disabled="disabled"
            />
          </a-form-item>
        </div>
        <div class="area-form" style="width: 588px">
          <a-form-item
            name="files"
            :required="true"
            :label="$t('pages_pay_389')"
          >
            <upload-auto
              ref="uploadFRef"
              v-model:file-content="editForm.files"
              list-type="picture"
              accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip,.rar"
              :explain="$t('pages_pay_388')"
              :max-count="10"
              :disabled="disabled"
            />
          </a-form-item>
        </div>
        <div v-if="!disabled" class="area-form" style="margin-top: 48px">
          <a-button
            type="primary"
            shape="round"
            style="min-width: 138px"
            :loading="loading"
            @click="handleSubmit"
          >{{ $t("common_text_002") }}</a-button>
          <a-button
            type="primary"
            shape="round"
            style="min-width: 138px; margin-left: 36px"
            ghost
            @click="handleReset"
          >{{ $t("common_text_040") }}</a-button>
        </div>
        <div v-else class="area-form" style="margin-top: 48px">
          <a-button
            type="primary"
            shape="round"
            style="min-width: 138px"
            ghost
            @click="$router.back(-1)"
          >{{ $t("common_text_003") }}</a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>
<script>
import HeaderNav from '@/components/header-nav'
import UploadAuto from '@/components/upload-auto'
import { ref, reactive, computed, toRefs } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { _pay } from '@/api'
import { message } from 'ant-design-vue'
import { getCountryLogo, getAttrStatusList } from '@/util'
import i18n from '@/locale'
export default {
  name: 'PayerC2CEdit',
  components: {
    'header-nav': HeaderNav,
    'upload-auto': UploadAuto
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const editRef = ref(null)
    const uploadRef = ref(null)
    const uploadFRef = ref(null)
    const state = reactive({
      loading: false,
      formLoading: false,
      spinLoading: false,
      outboundCountries: [],
      countries: [],
      provinces: [],
      cities: [],
      disabled: route.query.type && route.query.type === 'detail',
      editForm: {
        id: route.query.payerId,
        version: '',
        payerCountry: null,
        payerType: '00',
        paymentCurrency: null,
        paymentMode: '',
        provinceAddr: null,
        cityAddr: null,
        areaAddr: null,
        detailAddr: '',
        postalCode: '',
        holderType: '00',
        payerFirstName: '',
        payerLastName: '',
        identificationType: null,
        identificationNumber: '',
        contactNumber: '',
        emailAddress: '',
        occupation: '',
        fundSource: '',
        identityDocument: '',
        idExpiryDate: '',
        birthdate: '',
        files: '',
        status: ''
      }
    })
    state.certTypeList = computed(() => {
      return getAttrStatusList('certificateType')
    })
    state.sourceFunds = computed(() => {
      console.log(getAttrStatusList('payerSourceFunds'))
      return getAttrStatusList('payerSourceFunds')
    })

    const handleSubmit = () => {
      editRef.value.validateFields()
        .then(() => {
          state.loading = true
          const data = Object.assign({}, state.editForm, {})
          console.log(data, 'data+++++++++++')
          if (data.id) {
            data.status = '00'
            return _pay.payerInfoModify(data)
          }
          return _pay.payerInfoCreated(data)
        })
        .then(res => {
          state.loading = false
          if (res.data.succ) {
            message.success(state.editForm.id ? i18n.global.t('common_text_044') : i18n.global.t('common_text_043'))
            router.back(-1)
          } else {
            message.error(res.data.resMsg)
          }
        }).catch(err => {
          console.log(err)
          message.error(i18n.global.t('common_text_030'))
          state.loading = false
        })
    }

    const handleReset = () => {
      const { id } = state.editForm
      state.editForm.id = id
      state.editForm.payerCountry = null
      editRef.value.resetFields()
    }
    const loadPayeeDetail = async () => {
      // state.spinLoading = true
      const res = await _pay.payerInfoGetById(state.editForm.id)
      if (res.data.succ) {
        const { data } = res.data
        for (const i in state.editForm) {
          console.log(i, 'i+++++++')
          if (i === 'version') state.editForm[i] = data.newVersion
          else state.editForm[i] = data[i]
          if (i === 'identityDocument' && uploadRef.value) uploadRef.value.fileListRefresh(data[i].split(','))
          if (i === 'files' && uploadFRef.value)uploadFRef.value.fileListRefresh(data[i].split(','))
          if (i === 'birthdate' && data[i])state.editForm[i] = formatTimestamp(state.editForm[i])
          if (i === 'idExpiryDate' && data[i]) state.editForm[i] = formatTimestamp(state.editForm[i])
        }
        loadProvinces(data.provinceAddr, 'init')
        loadCities(data.cityAddr, 'init')
      } else {
        message.error(res.data.resMsg)
      }
      // state.spinLoading = false
    }
    const formatTimestamp = (timestamp) => {
      const date = new Date(timestamp)

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始，所以要加1
      const day = String(date.getDate()).padStart(2, '0') // 确保两位数字

      return `${year}-${month}-${day}`
    }
    const loadOutboundsCountries = async () => {
      const res = await _pay.getOutboundsCountries()
      if (res.data.succ) state.outboundCountries = res.data.data
    }

    const loadCountries = async () => {
      const res = await _pay.payeeCountry()
      if (res.data.succ) state.countries = res.data.data
    }

    const loadProvinces = async (payerCountry, method) => {
      console.log(123, payerCountry)
      if (method !== 'init') {
        state.editForm.cityAddr = null
        state.editForm.areaAddr = null
      }
      if (payerCountry) {
        const res = await _pay.payeeProvince({ countryCode: payerCountry })
        if (res.data.succ) state.provinces = res.data.data
      }
    }

    const loadCities = async (statesName, method) => {
      if (method !== 'init') state.editForm.areaAddr = null
      if (statesName) {
        const res = await _pay.payeeCity({ countryCode: state.editForm.provinceAddr, statesName })
        if (res.data.succ) state.cities = res.data.data
      }
    }

    const init = () => {
      loadCountries()
      loadOutboundsCountries()
      console.log(state.editForm.id)
      if (state.editForm.id) loadPayeeDetail()
    }

    init()

    return {
      editRef,
      getCountryLogo,
      handleReset,
      handleSubmit,
      loadOutboundsCountries,
      loadCountries,
      loadProvinces,
      loadCities,
      uploadRef,
      uploadFRef,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#payerC2CEdit {
  .common-card-body {
    padding: 36px 24px;

    .spinning-load {
      margin-top: 36px;
    }

    .payee-edit-form {
      margin-top: 36px;
      text-align: left;
      padding: 0 36px;

      .area-title {
        font-size: 15px;
        font-weight: 500;
        padding-bottom: 6px;
        border-bottom: 1px solid #f0f0f0;
        letter-spacing: 1px;
        margin-top: 24px;
      }

      .area-form {
        width: 500px;
        padding: 0 24px;
        margin-top: 24px;

        .ant-select {
          overflow: inherit;
        }

        .radio-left,
        .radio-right {
          width: 150px;
          padding: 0 58px;
          height: 35px;
          line-height: 35px;
          border-radius: 25px 0 0 25px;
        }

        .radio-right {
          border-radius: 0 25px 25px 0;
        }

        .input-primary:deep(.ant-input) {
          border-radius: 5px;
        }
      }
    }
  }
}
</style>
